import { InputTag } from "mixs/base/input_mixin";
import { Text } from "./text";
import { api } from "apps/api";
import Tether from "tether";
import App from "apps/application";

export class Typeahead extends Text {
  isFocus: boolean = false;
  index: number = -1;
  list:  HTMLDivElement;
  textfield: HTMLInputElement;
  hidden:    HTMLInputElement;
  onSelect: (id) => {}
  public init(){
    super.init();
    this.listenMount([this.onMountInputsTypeahead]);
  }
  public onInput(e) {
    this.lag.start(e.target.value);
  }
  protected onMountInputsTypeahead(){
    this.textfield = <HTMLInputElement>this.querySelector('input[type="text"]')
    this.hidden    = <HTMLInputElement>this.querySelector('input[type="hidden"]')
    this.list  = <HTMLDivElement>this.querySelector('.list')
  }
  protected onFocus(){
    this.isFocus = true;
    this.getItems();
  }
  protected onBlur(){
    this.isFocus = false;
    this.update();
    this.index = -1;
    window.removeEventListener('keydown', this.onKeyDown);
  }
  protected getItems(){
    let url = this.opts.get_action;
    let payload = {
      path: url,
      params: this.getParams()
    };
    api.typeahead(payload)
      .then((data) => {this.onGetItems(data)})
      .catch((error) => {this.onErrorGetItems(error);});
  }
  protected getParams(){
    let params = {
      s: {
        k: this.textfield.value
      }
    };
    if(this.opts.exceptions) {
      params['s']['e'] = this.opts.exceptions
    }
    if(this.opts.params) {
      for(let key in this.opts.params){
        params['s'][key] = this.opts.params[key]
      }
    }
    if(this.opts.opts) {
      for(let key in this.opts.opts){
        params[key] = this.opts.opts[key]
      }
    }
    if(this.opts.query) {
      let query_params_strings = this.opts.query.split('&');
      for(let i=0; i<query_params_strings.length; i++){
        let key_and_value = query_params_strings[i].split('=')
        params['s'][key_and_value[0]] = key_and_value[1];
      }
    }
    return params;
  }
  protected onGetItems(data){
    this.dispatch({candidates: data.data.candidates});
    this.update();
    this.setPosition();
    this.setScale();
    this.setKeyEvents();
  }
  protected onErrorGetItems(error){
  }
  protected setPosition(){
  }
  protected setScale(){
  }
  protected setKeyEvents(){
    window.addEventListener('keydown', this.onKeyDown)
  }
  protected onKeyDown(e){
    // let key:string = e.key;
    let key = e.charCode || e.keyCode || 0;
    if(key === 38){
      this.up();
    } else if(key === 40){
      this.down();
    } else if(key === 13){
      e.preventDefault();
      this.enter();
    }
  }
  protected enter(){
    if(this.index < 0){ return; };
    let element = this.getActiveElement();
    this.onSelectElement(element);
    this.textfield.blur();
  }
  protected up(){
    this.index = Math.max(this.index - 1, -1);
    this.update();
  }
  protected down(){
    this.index = Math.min(this.index + 1, this.opts.candidates.length - 1);
    this.update();
  }
  public onChangeLagged(params) {
    this.dispatch({value: params});
    if(!this.isFocus){ return; }
    this.getItems();
  }
  protected onSelectElement(element){

  }
  protected getActiveElement(): HTMLElement{
    return <HTMLElement>this.list.querySelector('.active');
  }
  protected getItemElements(){
    return this.list.querySelectorAll('.item');
  }
  public onClickItem(e){
    this.onSelectElement(e.currentTarget);
  }
}

export class InputsTypeahead extends Typeahead {
  protected setScale(){
    this.list.style.width = this.textfield.offsetWidth + 'px';
  }
  protected onSelectElement(element: HTMLElement){
    let id = element.getAttribute('data-id');
    this.hidden.value = id;
    let index = element.getAttribute('data-index');
    let selectedData = this.opts.candidates[parseInt(index)]
    if(selectedData.update != null){
      App.updatePlanner(selectedData.update)
    }
    let onSelect = this.opts.onSelect;
    if(!onSelect) onSelect = this.opts.onselect;
    if(onSelect){ onSelect(id, element); }
  }
  protected setPosition(){
    new Tether({
      element: this.list,
      target: this.textfield,
      attachment: 'top left',
      targetAttachment: 'bottom left'
    });
  }
}
class InputsTypeaheadMultiple extends InputTag {
  init(){
    super.init();
    this.watch();
  }
  onSelectItem(id, element){
    let items = this.opts.items;
    if(!Array.isArray(items)){ items = []}
    let exceptions = this.opts.typeahead.exceptions;
    if(!Array.isArray(exceptions)){ exceptions = []}
    let newVal = { items: null, typeahead: { exceptions: null} } ;
    items.push({
      id: id,
      text: element.textContent
    });
    exceptions.push(id);
    newVal['items'] = items;
    newVal['typeahead']['exceptions'] = exceptions;
    this.dispatchNewItems(newVal);
  }
  onClickRemoveBtn(e){
    let currentItems = this.opts.items;
    let items = [];
    let exceptions = []
    for(let i=0;i<currentItems.length; i++){
      let item = currentItems[i];
      if(e.item.id != item.id){
        items.push(item)
        exceptions.push(item.id);
      }
    }
    let newVal = { items: items, typeahead: { exceptions: exceptions } } ;
    this.dispatchNewItems(newVal);
  }
  dispatchNewItems(newVal){
    this.dispatch(newVal);
  }
}
class InputsTypeaheadDubble extends InputsTypeaheadMultiple {
  areFull(){
    if(this.opts.items == null){ return false; }
    if(this.opts.items.length >= 2){ return true; }
    return false;
  }
  areNotFull(){
    return !this.areFull();
  }
}
class InputsTypeaheadSingle extends InputTag {
  init(){
    super.init();
    if(this.opts.text == undefined) this.opts.text = ''
    this.watch();
  }
  onSelectItem(value, element){
    let newVal = {
      value: value,
      text: element.textContent
    }
    this.dispatch(newVal);
  }
  onClickRemoveBtn(e){
    let newVal = {
      value: '',
      text: ''
    }
    this.dispatch(newVal);
  }
}
riot.mixin("inputs.typeahead", InputsTypeahead as riot.TagMixin)
riot.mixin("inputs.typeahead-multiple", InputsTypeaheadMultiple as riot.TagMixin)
riot.mixin("inputs.typeahead-single", InputsTypeaheadSingle as riot.TagMixin)
riot.mixin("inputs.typeahead-dubble", InputsTypeaheadDubble as riot.TagMixin)
